/**
 * Orden visual de la grilla unificada (plan §9.2). Función PURA.
 * - conserva el orden de los apartamentos identificados (named);
 * - intercala las categorías por asignación (que el caller ya ordenó por
 *   search_priority) sin usar rating ni piso inventados;
 * - inserta la primera categoría tras INSERT_FIRST_AFTER unidades nombradas y
 *   las siguientes cada INSERT_EVERY unidades;
 * - si faltan nombradas, agrega las categorías restantes al final.
 */
import type { SearchResultItem, AssignmentListingDTO } from './public-types';

/** Constantes medibles (no números dispersos en JSX). */
export const INSERT_FIRST_AFTER = 2;
export const INSERT_EVERY = 3;

export function mergeSearchResults(
  named: SearchResultItem[],
  assignmentOrdered: AssignmentListingDTO[]
): SearchResultItem[] {
  const assignmentItems: SearchResultItem[] = assignmentOrdered.map((product) => ({
    kind: 'assignment',
    key: `assignment:${product.slug}`,
    product,
  }));

  const out: SearchResultItem[] = [];
  let ai = 0;

  for (let i = 0; i < named.length; i++) {
    out.push(named[i]);
    const pushed = i + 1;
    const isInsertionPoint =
      pushed === INSERT_FIRST_AFTER ||
      (pushed > INSERT_FIRST_AFTER && (pushed - INSERT_FIRST_AFTER) % INSERT_EVERY === 0);
    if (isInsertionPoint && ai < assignmentItems.length) {
      out.push(assignmentItems[ai++]);
    }
  }

  // Categorías restantes (incluye el caso de pocas/ninguna unidad nombrada).
  while (ai < assignmentItems.length) out.push(assignmentItems[ai++]);

  return out;
}
